import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function TelegramIcon(props: IconRenderProps): ReactElement {
	const bg = props.customIconColor?.bgColor ?? '#FFFFFF';
	const g = props.customIconColor?.glyphColor ?? (props.active ? '#1E1E1E' : 'rgba(30, 30, 30, 0.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={props.width ?? '100%'}
			height={props.height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label="Telegram"
			style={{ display: 'block', ...props.style }}
		>
			<rect width="40" height="40" rx="8" fill={bg} />
			<path
				fill={g}
				d="M30.4 11.8L26.9 28c-.3 1.2-.9 1.5-1.9 1l-5.3-3.9-2.6 2.5c-.3.3-.5.5-1.1.5l.4-5.4 9.9-8.9c.4-.4-.1-.6-.7-.2l-12.3 7.7-5.3-1.7c-1.2-.4-1.2-1.2.2-1.7l20.7-8c1-.4 1.8.2 1.5 1.9z"
			/>
		</svg>
	);
}
